import {UseCase} from '@s-ui/domain'

const isRequired = field => {
  throw new Error(`BrazeUserRepository# ${field} is a mandatory parameter`)
}

class UpdateBrazeUserUseCase extends UseCase {
  constructor({repository}) {
    super({repository})

    this._repository = repository
  }

  execute({
    id = isRequired('id'),
    firstName = isRequired('firstName'),
    lastName = null,
    email = isRequired('email'),
    isEmailConfirmed = null,
    phoneNumber = null
  }) {
    return this._repository.update({
      id,
      firstName,
      lastName,
      email,
      isEmailConfirmed,
      phoneNumber
    })
  }
}

export default UpdateBrazeUserUseCase
